import { IAction } from "../../../../models/Action";
import emptyState from "./emptyState";
import { STATE_IDENTIFIER } from "./constants";
import { actionTypes } from "./actions";
import { immutableSet } from "../../../../utils/immutable";
import { compose } from "redux";
import { IDENTITY_SYSTEM } from "../../../../module/constants";
import {
  TechnicalIdentity,
  TechnicalUserApplicationCounter,
  TechnicalUserCounter,
} from "../../../../models/TechnicalUsers";
import { IResponseState } from "../../../../components/Modals/ResponseModal/module/constants";

const {
  ALL_COUNTERS,
  APP_COUNTERS,
  OU_COUNTERS,
  LIST,
  LOADER,
  COUNTER_CALL_STATE,
  RIORG_IDENTITY,
  RIORG_OUS,
  RIORG_CALL_STATE,
} = STATE_IDENTIFIER;

const ACTION_HANDLERS = {
  [actionTypes.GET_ALL_COUNTERS]: (state: any, action: any) =>
    immutableSet([ALL_COUNTERS, LOADER], true, state),
  [actionTypes.GET_ALL_COUNTERS_SUCCESS]: (state: any, action: any) => {
    const mappedResponse = [];
    if (action && action.payload) {
      for (let i = 0; i < action.payload.length; i++) {
        const tempCounter: TechnicalUserCounter = action.payload[i];
        mappedResponse.push({
          ...tempCounter,
          active: tempCounter.active !== null && `${tempCounter.active}`,
          default: tempCounter.default !== null && `${tempCounter.default}`,
        });
      }
    }
    return compose(
      immutableSet([ALL_COUNTERS, LIST], mappedResponse),
      immutableSet([ALL_COUNTERS, LOADER], false)
    )(state);
  },
  [actionTypes.GET_ALL_COUNTERS_FAILURE]: (state: any, action: any) => {
    return compose(
      immutableSet([ALL_COUNTERS, LIST], []),
      immutableSet([ALL_COUNTERS, LOADER], false)
    )(state);
  },

  [actionTypes.GET_APP_COUNTERS]: (state: any, action: any) =>
    immutableSet([APP_COUNTERS, LOADER], true, state),
  [actionTypes.GET_APP_COUNTERS_SUCCESS]: (state: any, action: any) => {
    const mappedResponse = [];
    if (action && action.payload) {
      for (let i = 0; i < action.payload.length; i++) {
        const tempCounter: TechnicalUserApplicationCounter = action.payload[i];
        mappedResponse.push({
          ...tempCounter,
          identitySystemId:
            IDENTITY_SYSTEM[
              tempCounter.identitySystemId as keyof typeof IDENTITY_SYSTEM
            ],
        });
      }
    }
    return compose(
      immutableSet([APP_COUNTERS, LIST], mappedResponse),
      immutableSet([APP_COUNTERS, LOADER], false)
    )(state);
  },
  [actionTypes.GET_APP_COUNTERS_FAILURE]: (state: any, action: any) => {
    return compose(
      immutableSet([APP_COUNTERS, LIST], []),
      immutableSet([APP_COUNTERS, LOADER], false)
    )(state);
  },

  [actionTypes.GET_OU_COUNTERS]: (state: any, action: any) =>
    immutableSet([OU_COUNTERS, LOADER], true, state),
  [actionTypes.GET_OU_COUNTERS_SUCCESS]: (state: any, action: any) => {
    const mappedResponse = [];
    if (action.payload && action.payload.length > 0) {
      for (let i = 0; i < action.payload.length; i++) {
        const currentEl = action.payload[i];
        const temp = {
          counterCode: currentEl.counterCode,
          ouCode: currentEl.ouCode,
          description: currentEl.description,
        };

        mappedResponse.push(temp);
      }
    }
    return compose(
      immutableSet([OU_COUNTERS, LIST], mappedResponse),
      immutableSet([OU_COUNTERS, LOADER], false)
    )(state);
  },
  [actionTypes.GET_OU_COUNTERS_FAILURE]: (state: any, action: any) => {
    return compose(
      immutableSet([OU_COUNTERS, LIST], []),
      immutableSet([OU_COUNTERS, LOADER], false)
    )(state);
  },

  [actionTypes.GET_RIORG_TECHNICAL_IDENTITY]: (state: any, action: any) => {
    return compose(
      immutableSet([RIORG_IDENTITY, LIST], []),
      immutableSet([RIORG_IDENTITY, LOADER], true)
    )(state);
  },
  [actionTypes.GET_RIORG_TECHNICAL_IDENTITY_SUCCES]: (
    state: any,
    action: any
  ) => {
    const mappedResponse: TechnicalIdentity[] = [];

    if (action.payload && action.payload.length > 0) {
      for (let i = 0; i < action.payload.length; i++) {
        const currTechIdentity: TechnicalIdentity = action.payload[i];
        const tempIdntitiy: TechnicalIdentity = {
          tiCode: currTechIdentity.tiCode,
          oldOuCode: currTechIdentity.oldOuCode,
          oldManager:
            currTechIdentity.oldManager + currTechIdentity.oldManagerCode
              ? `[${currTechIdentity.oldManagerCode}]`
              : "",
          newOuCode: currTechIdentity.newOuCode,
          identitySystemId:
            IDENTITY_SYSTEM[
              currTechIdentity.identitySystemId as keyof typeof IDENTITY_SYSTEM
            ],
        };
        mappedResponse.push(tempIdntitiy);
      }
    }
    return compose(
      immutableSet([RIORG_IDENTITY, LIST], mappedResponse),
      immutableSet([RIORG_IDENTITY, LOADER], false)
    )(state);
  },
  [actionTypes.GET_RIORG_TECHNICAL_IDENTITY_FAILURE]: (
    state: any,
    action: any
  ) => {
    return compose(
      immutableSet([RIORG_IDENTITY, LIST], []),
      immutableSet([RIORG_IDENTITY, LOADER], false)
    )(state);
  },

  [actionTypes.GET_RIORG_OU]: (state: any, action: any) => {
    return immutableSet([RIORG_OUS], [], state);
  },
  [actionTypes.GET_RIORG_OU_SUCCES]: (state: any, action: any) => {
    return immutableSet([RIORG_OUS], action.payload, state);
  },
  [actionTypes.GET_RIORG_OU_FAILURE]: (state: any, action: any) => {
    return immutableSet([RIORG_OUS], [], state);
  },

  [actionTypes.ADD_TECHNICAL_COUNTER]: (state: any, action: any) =>
    immutableSet([COUNTER_CALL_STATE], IResponseState.PENDING, state),
  [actionTypes.ADD_TECHNICAL_COUNTER_SUCCESS]: (state: any, action: any) =>
    immutableSet([COUNTER_CALL_STATE], IResponseState.SUCCESS, state),
  [actionTypes.ADD_TECHNICAL_COUNTER_FAILURE]: (state: any, action: any) =>
    immutableSet([COUNTER_CALL_STATE], IResponseState.ERROR, state),

  [actionTypes.UPDATE_TECHNICAL_COUNTER]: (state: any, action: any) =>
    immutableSet([COUNTER_CALL_STATE], IResponseState.PENDING, state),
  [actionTypes.UPDATE_TECHNICAL_COUNTER_SUCCESS]: (state: any, action: any) =>
    immutableSet([COUNTER_CALL_STATE], IResponseState.SUCCESS, state),
  [actionTypes.UPDATE_TECHNICAL_COUNTER_FAILURE]: (state: any, action: any) =>
    immutableSet([COUNTER_CALL_STATE], IResponseState.ERROR, state),

  [actionTypes.DELETE_TECHNICAL_COUNTER]: (state: any, action: any) =>
    immutableSet([COUNTER_CALL_STATE], IResponseState.PENDING, state),
  [actionTypes.DELETE_TECHNICAL_COUNTER_SUCCESS]: (state: any, action: any) =>
    immutableSet([COUNTER_CALL_STATE], IResponseState.SUCCESS, state),
  [actionTypes.DELETE_TECHNICAL_COUNTER_FAILURE]: (state: any, action: any) =>
    immutableSet([COUNTER_CALL_STATE], IResponseState.ERROR, state),

  [actionTypes.RIORG_OU]: (state: any, action: any) =>
    immutableSet([RIORG_CALL_STATE], IResponseState.PENDING, state),
  [actionTypes.RIORG_OU_SUCCES]: (state: any, action: any) =>
    immutableSet([RIORG_CALL_STATE], IResponseState.SUCCESS, state),
  [actionTypes.RIORG_OU_FAILURE]: (state: any, action: any) =>
    immutableSet([RIORG_CALL_STATE], IResponseState.ERROR, state),
};

export default function communicationReducer(
  state = emptyState,
  action: IAction
) {
  if (
    action &&
    action.type === "@@router/LOCATION_CHANGE" &&
    (action.payload.location.pathname === "/welcome" ||
      action.payload.location.pathname === "/admin")
  ) {
    return emptyState;
  }
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
